import {environment} from '../../../environments/environment';

export const TOKEN = {
  ACCESS_TOKEN : 'access_token' + (environment.production ? '' : '_dev'),
  REFRESH_TOKEN : 'refresh_token' + (environment.production ? '' : '_dev'),
  ROLE : 'role_user',
  USER : 'user',
  TODO_MODAL_OPENED : 'todo_modal_opened',
}
